import { render, staticRenderFns } from "./CohortFields.vue?vue&type=template&id=1735c4a9&scoped=true&"
import script from "./CohortFields.vue?vue&type=script&lang=js&"
export * from "./CohortFields.vue?vue&type=script&lang=js&"
import style0 from "./CohortFields.vue?vue&type=style&index=0&id=1735c4a9&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1735c4a9",
  null
  
)

export default component.exports